/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClearAccountFeatureFlag200Item
} from './model/clearAccountFeatureFlag200Item.js';

import type {
  FeatureFlag
} from './model/featureFlag.js';

import type {
  FlagUserOverride
} from './model/flagUserOverride.js';

import type {
  ListAccountFeatureFlags200Item
} from './model/listAccountFeatureFlags200Item.js';

import type {
  SetAccountFeatureFlag200Item
} from './model/setAccountFeatureFlag200Item.js';

import type {
  SetAccountFeatureFlagBody
} from './model/setAccountFeatureFlagBody.js';

import type {
  SetFeatureFlagBody
} from './model/setFeatureFlagBody.js';

import type {
  SetFeatureFlagOverrideBody
} from './model/setFeatureFlagOverrideBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List all feature flags.
 */
export const listFeatureFlags = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<FeatureFlag[]>(
      {url: `/flags`, method: 'GET', signal
    },
      options);
    }




export const getListFeatureFlagsQueryKey = () => {
    return [
    `/flags`
    ] as const;
    }


export const getListFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof listFeatureFlags>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFeatureFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatureFlags>>> = ({ signal }) => listFeatureFlags(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData> & { queryKey: QueryKey }
}

export type ListFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeatureFlags>>>
export type ListFeatureFlagsQueryError = unknown


/**
 * @summary List all feature flags.
 */

export function useListFeatureFlags<TData = Awaited<ReturnType<typeof listFeatureFlags>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listFeatureFlags>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Enable or disable a feature flag.
 */
export const setFeatureFlag = (
    key: string,
    setFeatureFlagBody: SetFeatureFlagBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<FeatureFlag[]>(
      {url: `/flags/${encodeURIComponent(String(key))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setFeatureFlagBody, signal
    },
      options);
    }




export const getSetFeatureFlagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlag>>, TError,{key: string;data: SetFeatureFlagBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlag>>, TError,{key: string;data: SetFeatureFlagBody}, TContext> => {

const mutationKey = ['setFeatureFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setFeatureFlag>>, {key: string;data: SetFeatureFlagBody}> = (props) => {
          const {key,data} = props ?? {};

          return  setFeatureFlag(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof setFeatureFlag>>>
    export type SetFeatureFlagMutationBody = SetFeatureFlagBody
    export type SetFeatureFlagMutationError = unknown

    /**
 * @summary Enable or disable a feature flag.
 */
export const useSetFeatureFlag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlag>>, TError,{key: string;data: SetFeatureFlagBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setFeatureFlag>>,
        TError,
        {key: string;data: SetFeatureFlagBody},
        TContext
      > => {
      return useMutation(getSetFeatureFlagMutationOptions(options));
    }
    /**
 * @summary List a flag's per-user overrides.
 */
export const getFeatureFlagOverrides = (
    key: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<FlagUserOverride[]>(
      {url: `/flags/${encodeURIComponent(String(key))}/overrides`, method: 'GET', signal
    },
      options);
    }




export const getGetFeatureFlagOverridesQueryKey = (key: string,) => {
    return [
    `/flags/${key}/overrides`
    ] as const;
    }


export const getGetFeatureFlagOverridesQueryOptions = <TData = Awaited<ReturnType<typeof getFeatureFlagOverrides>>, TError = unknown>(key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlagOverrides>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeatureFlagOverridesQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureFlagOverrides>>> = ({ signal }) => getFeatureFlagOverrides(key, requestOptions, signal);





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlagOverrides>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFeatureFlagOverridesQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatureFlagOverrides>>>
export type GetFeatureFlagOverridesQueryError = unknown


/**
 * @summary List a flag's per-user overrides.
 */

export function useGetFeatureFlagOverrides<TData = Awaited<ReturnType<typeof getFeatureFlagOverrides>>, TError = unknown>(
 key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFeatureFlagOverrides>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFeatureFlagOverridesQueryOptions(key,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Set a user's override for an account-scoped flag.
 */
export const setFeatureFlagOverride = (
    key: string,
    userId: string,
    setFeatureFlagOverrideBody: SetFeatureFlagOverrideBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<FlagUserOverride[]>(
      {url: `/flags/${encodeURIComponent(String(key))}/overrides/${encodeURIComponent(String(userId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setFeatureFlagOverrideBody, signal
    },
      options);
    }




export const getSetFeatureFlagOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagOverride>>, TError,{key: string;userId: string;data: SetFeatureFlagOverrideBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagOverride>>, TError,{key: string;userId: string;data: SetFeatureFlagOverrideBody}, TContext> => {

const mutationKey = ['setFeatureFlagOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setFeatureFlagOverride>>, {key: string;userId: string;data: SetFeatureFlagOverrideBody}> = (props) => {
          const {key,userId,data} = props ?? {};

          return  setFeatureFlagOverride(key,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetFeatureFlagOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setFeatureFlagOverride>>>
    export type SetFeatureFlagOverrideMutationBody = SetFeatureFlagOverrideBody
    export type SetFeatureFlagOverrideMutationError = unknown

    /**
 * @summary Set a user's override for an account-scoped flag.
 */
export const useSetFeatureFlagOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFeatureFlagOverride>>, TError,{key: string;userId: string;data: SetFeatureFlagOverrideBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setFeatureFlagOverride>>,
        TError,
        {key: string;userId: string;data: SetFeatureFlagOverrideBody},
        TContext
      > => {
      return useMutation(getSetFeatureFlagOverrideMutationOptions(options));
    }
    /**
 * @summary Clear a user's override for an account-scoped flag.
 */
export const deleteFeatureFlagOverride = (
    key: string,
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<FlagUserOverride[]>(
      {url: `/flags/${encodeURIComponent(String(key))}/overrides/${encodeURIComponent(String(userId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteFeatureFlagOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFeatureFlagOverride>>, TError,{key: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFeatureFlagOverride>>, TError,{key: string;userId: string}, TContext> => {

const mutationKey = ['deleteFeatureFlagOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFeatureFlagOverride>>, {key: string;userId: string}> = (props) => {
          const {key,userId} = props ?? {};

          return  deleteFeatureFlagOverride(key,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFeatureFlagOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFeatureFlagOverride>>>

    export type DeleteFeatureFlagOverrideMutationError = unknown

    /**
 * @summary Clear a user's override for an account-scoped flag.
 */
export const useDeleteFeatureFlagOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFeatureFlagOverride>>, TError,{key: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFeatureFlagOverride>>,
        TError,
        {key: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteFeatureFlagOverrideMutationOptions(options));
    }
    /**
 * @summary List account feature flags
 */
export const listAccountFeatureFlags = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAccountFeatureFlags200Item[]>(
      {url: `/flags/account`, method: 'GET', signal
    },
      options);
    }




export const getListAccountFeatureFlagsQueryKey = () => {
    return [
    `/flags/account`
    ] as const;
    }


export const getListAccountFeatureFlagsQueryOptions = <TData = Awaited<ReturnType<typeof listAccountFeatureFlags>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountFeatureFlags>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccountFeatureFlagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountFeatureFlags>>> = ({ signal }) => listAccountFeatureFlags(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccountFeatureFlags>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccountFeatureFlagsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccountFeatureFlags>>>
export type ListAccountFeatureFlagsQueryError = unknown


/**
 * @summary List account feature flags
 */

export function useListAccountFeatureFlags<TData = Awaited<ReturnType<typeof listAccountFeatureFlags>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccountFeatureFlags>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccountFeatureFlagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Set an account feature flag
 */
export const setAccountFeatureFlag = (
    key: string,
    setAccountFeatureFlagBody: SetAccountFeatureFlagBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<SetAccountFeatureFlag200Item[]>(
      {url: `/flags/account/${encodeURIComponent(String(key))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAccountFeatureFlagBody, signal
    },
      options);
    }




export const getSetAccountFeatureFlagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAccountFeatureFlag>>, TError,{key: string;data: SetAccountFeatureFlagBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAccountFeatureFlag>>, TError,{key: string;data: SetAccountFeatureFlagBody}, TContext> => {

const mutationKey = ['setAccountFeatureFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAccountFeatureFlag>>, {key: string;data: SetAccountFeatureFlagBody}> = (props) => {
          const {key,data} = props ?? {};

          return  setAccountFeatureFlag(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAccountFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof setAccountFeatureFlag>>>
    export type SetAccountFeatureFlagMutationBody = SetAccountFeatureFlagBody
    export type SetAccountFeatureFlagMutationError = unknown

    /**
 * @summary Set an account feature flag
 */
export const useSetAccountFeatureFlag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAccountFeatureFlag>>, TError,{key: string;data: SetAccountFeatureFlagBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAccountFeatureFlag>>,
        TError,
        {key: string;data: SetAccountFeatureFlagBody},
        TContext
      > => {
      return useMutation(getSetAccountFeatureFlagMutationOptions(options));
    }
    /**
 * @summary Clear an account feature flag
 */
export const clearAccountFeatureFlag = (
    key: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ClearAccountFeatureFlag200Item[]>(
      {url: `/flags/account/${encodeURIComponent(String(key))}`, method: 'DELETE', signal
    },
      options);
    }




export const getClearAccountFeatureFlagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAccountFeatureFlag>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearAccountFeatureFlag>>, TError,{key: string}, TContext> => {

const mutationKey = ['clearAccountFeatureFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearAccountFeatureFlag>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  clearAccountFeatureFlag(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearAccountFeatureFlagMutationResult = NonNullable<Awaited<ReturnType<typeof clearAccountFeatureFlag>>>

    export type ClearAccountFeatureFlagMutationError = unknown

    /**
 * @summary Clear an account feature flag
 */
export const useClearAccountFeatureFlag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearAccountFeatureFlag>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof clearAccountFeatureFlag>>,
        TError,
        {key: string},
        TContext
      > => {
      return useMutation(getClearAccountFeatureFlagMutationOptions(options));
    }
